$ ->
  if $('body').is('.information-gamification-page')
    animateChallenges =
      init: ->
        @cacheDom()
        @bindEvent()

      cacheDom: ->
        @$window = $(window)
        @$elChallenge = $ '.gamification-info--challenges'
        @$iconLeft = $ '.gamification-info__icon--cloud-1', @$elChallenge
        @$iconRight = $ '.gamification-info__icon--cloud-2', @$elChallenge
        @$elAward = $ '.award-badges'
        @scrolledToChallenge = false
        @scrolledToAward = false

      bindEvent: ->
        @$window.on 'scroll', => @animateInfo()

      animateInfo: ->
        window_top = @$window.scrollTop() + 50
        challenge_top_pos = @$elChallenge.offset().top
        award_top_pos = @$elAward.offset().top

        if (challenge_top_pos <= window_top) && !@scrolledToChallenge
          @$iconLeft.animate { left: '200px' }, 1000
          @$iconRight.animate { right: '215px' }, 1000
          @scrolledToChallenge = true
        else if (challenge_top_pos >= window_top) && @scrolledToChallenge
          @$iconLeft.animate { left: '110px' }, 1000
          @$iconRight.animate { right: '125px' }, 1000
          @scrolledToChallenge = false

        if (award_top_pos <= window_top) && !@scrolledToAward
          @$elAward.animate { top: '0px' }, 1000
          @scrolledToAward = true
        else if (award_top_pos >= window_top) && @scrolledToAward
          @$elAward.animate { top: '-35px'  }, 1000
          @scrolledToAward = false

    animateChallenges.init()
